// 異常アラート一覧。anomalies[] を severity 降順で列挙し、行クリックで地点選択。

const SCOPE_LABEL = { chokepoint: "チョークポイント", port: "港" };

// 理由文はバッチ側の reason ではなくここで組み立てる（判定の主指標である σ を先頭に置く）。
function reasonOf(a) {
  if (a.sigma == null || a.pctChange == null) return a.reason;
  const sign = a.pctChange >= 0 ? "+" : "";
  return `${a.label} ${a.sigma}σ / 前月比 ${sign}${a.pctChange}%`;
}

function AlertList({ anomalies, onSelect }) {
  if (!anomalies || anomalies.length === 0) {
    return <p className="empty-state">異常は検知されていません</p>;
  }

  return (
    <ul className="alert-list">
      {anomalies.map((a) => (
        <li key={`${a.scope}-${a.portid}-${a.metric}`}>
          <button
            type="button"
            className={`alert-item is-${a.severity}`}
            onClick={() => onSelect?.(a.portid)}
          >
            <span className="dot" />
            <span className="alert-body">
              <span className="alert-name">{a.portname}</span>
              <span className="alert-reason">{reasonOf(a)}</span>
              <span className="alert-scope">
                {SCOPE_LABEL[a.scope] ?? a.scope}
                {a.country ? ` · ${a.country}` : ""}
              </span>
            </span>
          </button>
        </li>
      ))}
    </ul>
  );
}

export default AlertList;
